import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Button,
  Checkbox,
  Dropdown,
  TextArea,
  Input
} from 'semantic-ui-react'

const CardSurgeryTeamUX = (props: any) => {
    return(
      <div
        id="CardSurgeryTeam"
        style={{width:"100%", padding: "1rem", backgroundColor: "#D6ECF33B"}}>
        <div
          id="CardSurgeryTeamUX-div-1"
          style={{display: "grid", gridTemplateColumns: "115px 1fr"}}>
          
          <div
            className="ui form"
            id="CardSurgeryTeamUX-div-5"
            style={{paddingTop: "8px"}}>
            
            <Checkbox
              checked={props.isMain || false}
              id="CardSurgeryTeamUX-Checkbox-30"
              label="Main Team"
              name="is_main"
              onChange={props.onChangeValue}>
            </Checkbox>
          </div>
          <div
            className="ui form"
            id="CardSurgeryTeamUX-div-6">
            
            <FormGroup
              id="CardSurgeryTeamUX-FormGroup-8"
              inline={true}>
              <FormField
                id="CardSurgeryTeamUX-FormField-10"
                inline={true}
                style={{padding: 0, width: "127px"}}>
                <label
                  id="CardSurgeryTeamUX-label-14"
                  style={{fontWeight: "bold", margin: 0}}>
                  แพทย์ผ่าตัด
                </label>
                <label
                  id="CardSurgeryTeamUX-label-15"
                  style={{color: "red"}}>
                  *
                </label>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-11"
                inline={true}
                width={5}>
                <div
                  id="CardSurgeryTeamUX-div-77"
                  style={{width: "100%"}}>
                  {props.SurgeonElement}
                </div>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-12"
                inline={true}
                width={8}>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-13"
                inline={true}
                width={3}>
                <Button
                  color={"red"}
                  disabled={props.isReadOnly}
                  fluid={true}
                  id="CardSurgeryTeamUX-Button-18"
                  onClick={props.onDeleteTeam}
                  style={{minWidth: "max-content"}}>
                  Delete Team
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSurgeryTeamUX-FormGroup-52">
              <FormField
                id="CardSurgeryTeamUX-FormField-53"
                inline={true}
                style={{width: "110px", paddingTop: "0.55rem", paddingRight: 0}}>
                <label
                  id="CardSurgeryTeamUX-label-55">
                  แพทย์ผ่าตัดร่วม
                </label>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-54"
                inline={true}
                width={14}>
                <div
                  id="CardSurgeryTeamUX-div-56"
                  style={{width: "100%"}}>
                  {props.AssistantsElement}
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
        <div
          id="CardSurgeryTeamUX-div-2"
          style={{display: "grid", gridTemplateColumns: "115px 1fr", marginTop: "-1rem"}}>
          
          <div
            className="ui form"
            id="CardSurgeryTeamUX-div-31"
            style={{display: "flex", alignItems: "center"}}>
            
            <label
              id="CardSurgeryTeamUX-label-33"
              style={{fontWeight: "bold"}}>
              Implant
            </label>
          </div>
          <div
            className="ui form"
            id="CardSurgeryTeamUX-div-32">
            
            <FormField
              id="CardSurgeryTeamUX-FormField-34"
              inline={true}
              width={5}>
              <Dropdown
                allowAdditions={true}
                id="CardSurgeryTeamUX-Dropdown-35"
                multiple={true}
                name="implant"
                onAddItem={props.onAddition}
                onChange={props.onChangeValue}
                options={props.orImplantOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.implant || []}>
              </Dropdown>
            </FormField>
          </div>
        </div>
        <div
          id="CardSurgeryTeamUX-div-3"
          style={{display: "grid", gridTemplateColumns: "115px 1fr", marginTop: "1rem"}}>
          
          <div
            className="ui form"
            id="CardSurgeryTeamUX-div-36"
            style={{display: "flex", alignItems: "center"}}>
            
            <label
              id="CardSurgeryTeamUX-label-38"
              style={{fontWeight: "bold"}}>
              Operation
            </label>
          </div>
          <div
            className="ui form"
            id="CardSurgeryTeamUX-div-37"
            style={{border: "1px solid rgba(214,236,243,1)", padding: "1rem 0.5rem"}}>
            
            <FormGroup
              id="CardSurgeryTeamUX-FormGroup-39"
              style={{marginBottom: 0, display: props.config?.hideOperatingTreatment?"none":""}}>
              <FormField
                id="CardSurgeryTeamUX-FormField-43"
                inline={true}
                style={{minWidth: "max-content"}}
                width={2}>
                <label
                  id="CardSurgeryTeamUX-label-46"
                  style={{fontWeight: "bold", paddingTop: "8px", margin: 0}}>
                  รายการหัตถการ
                </label>
                <label
                  id="CardSurgeryTeamUX-label-47"
                  style={{color: "red"}}>
                  *
                </label>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-44"
                inline={true}
                width={14}>
                <div
                  id="CardSurgeryTeamUX-div-57"
                  style={{width: "100%"}}>
                  {props.TreatmentElement}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSurgeryTeamUX-FormGroup-40"
              inline={true}>
              <FormField
                id="CardSurgeryTeamUX-FormField-58"
                inline={true}>
                <label
                  id="CardSurgeryTeamUX-label-65"
                  style={{fontWeight: "bold"}}>
                  Other detail
                </label>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-59"
                inline={true}
                width={10}>
                <TextArea
                  id="CardSurgeryTeamUX-TextArea-95"
                  name="pre_operating_order_item.other_treatment"
                  onChange={props.onChangeValue}
                  rows="5"
                  value={props.otherTreatment || ""}>
                </TextArea>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSurgeryTeamUX-FormGroup-82"
              inline={true}>
              <FormField
                id="CardSurgeryTeamUX-FormField-83"
                inline={true}>
                <label
                  id="CardSurgeryTeamUX-label-89"
                  style={{fontWeight: "bold", minWidth: "70px", maxWidth: "70px"}}>
                  Position
                </label>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-84"
                inline={true}
                width={7}>
                <Dropdown
                  fluid={true}
                  id="CardSurgeryTeamUX-Dropdown-90"
                  name="pre_operating_order_item.position"
                  onChange={props.onChangeValue}
                  options={props.otherTrtPositionOptions || []}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.position || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-85"
                inline={true}>
                <Input
                  id="CardSurgeryTeamUX-Input-91"
                  name="pre_operating_order_item.other_position"
                  onChange={props.onChangeValue}
                  placeholder="Other position"
                  style={{display: props.config?.showOtherPosition ? "": "none"}}
                  value={props.otherPosition || ""}>
                </Input>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-86"
                inline={true}>
                <label
                  id="CardSurgeryTeamUX-label-92"
                  style={{fontWeight: "bold"}}>
                  Site
                </label>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-87"
                inline={true}>
                <Checkbox
                  checked={props.siteRight || false}
                  id="CardSurgeryTeamUX-Checkbox-93"
                  label="Right"
                  name="pre_operating_order_item.site_right"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardSurgeryTeamUX-FormField-88"
                inline={true}>
                <Checkbox
                  checked={props.siteLeft || false}
                  id="CardSurgeryTeamUX-Checkbox-94"
                  label="Left"
                  name="pre_operating_order_item.site_left"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
            </FormGroup>
            <div
              id="CardSurgeryTeamUX-div-72"
              style={{width: "100%"}}>
              {props.ProvisionDiagElement}
            </div>
          </div>
        </div>
        <div
          id="CardSurgeryTeamUX-div-4"
          style={{display: "grid", gridTemplateColumns: "115px 1fr", marginTop: "1rem"}}>
          
          <div
            className="ui form"
            id="CardSurgeryTeamUX-div-73"
            style={{display: "flex", alignItems: "center",paddingRight: "55px"}}>
            
            <label
              id="CardSurgeryTeamUX-label-75"
              style={{fontWeight: "bold",textAlign: "center", padding: "-1px"}}>
              Preoperative diagnosis
            </label>
          </div>
          <div
            className="ui form"
            id="CardSurgeryTeamUX-div-74"
            style={{border: "1px solid rgba(214,236,243,1)", padding: "1rem 0.5rem"}}>
            
            <div
              id="CardSurgeryTeamUX-div-76"
              style={{width: "100%", paddingBottom: "10px" }}>
              {props.PreoperativeDiagElement}
            </div>
            <label
              id="CardSurgeryTeamUX-label-81"
              style={{fontWeight: "bold",textAlign: "center", display: props.config?.hideDiagnosisRemark? "none": ""}}>
              รายละเอียดเพิ่มเติม
            </label>
            <TextArea
              id="CardSurgeryTeamUX-TextArea-80"
              name="diagnosis_remark"
              onChange={props.onChangeValue}
              style={{ marginTop: "10px" , display: props.config?.hideDiagnosisRemark? "none": ""}}
              value={props.diagnosis_remark || ""}>
            </TextArea>
          </div>
        </div>
      </div>
    )
}


export default CardSurgeryTeamUX

export const screenPropsDefault = {}

/* Date Time : Wed Jun 11 2025 12:19:07 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeam"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"1rem\", backgroundColor: \"#D6ECF33B\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"115px 1fr\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"115px 1fr\", marginTop: \"-1rem\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"115px 1fr\", marginTop: \"1rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"115px 1fr\", marginTop: \"1rem\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"8px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormGroup-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0, width: \"127px\"}"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผ่าตัด"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-14"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: 0}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-15"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Button",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "Delete Team"
        },
        "color": {
          "type": "code",
          "value": "\"red\""
        },
        "disabled": {
          "type": "code",
          "value": "props.isReadOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-Button-18"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDeleteTeam"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Checkbox",
      "parent": 5,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isMain || false"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-Checkbox-30"
        },
        "label": {
          "type": "value",
          "value": "Main Team"
        },
        "name": {
          "type": "value",
          "value": "is_main"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "Implant"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-33"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-34"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Dropdown",
      "parent": 34,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-Dropdown-35"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "implant"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddition"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.orImplantOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.implant || []"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{border: \"1px solid rgba(214,236,243,1)\", padding: \"1rem 0.5rem\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "Operation"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormGroup",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormGroup-39"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: 0, display: props.config?.hideOperatingTreatment?\"none\":\"\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormGroup",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormGroup-40"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการหัตถการ"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-46"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", paddingTop: \"8px\", margin: 0}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-47"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormGroup",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormGroup-52"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"110px\", paddingTop: \"0.55rem\", paddingRight: 0}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผ่าตัดร่วม"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-55"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "code",
          "value": "props.AssistantsElement"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TreatmentElement"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-58"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "label",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "Other detail"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-65"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ProvisionDiagElement"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",paddingRight: \"55px\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{border: \"1px solid rgba(214,236,243,1)\", padding: \"1rem 0.5rem\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "Preoperative diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-75"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",textAlign: \"center\", padding: \"-1px\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 74,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PreoperativeDiagElement"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", paddingBottom: \"10px\" }"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SurgeonElement"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "TextArea",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-TextArea-80"
        },
        "name": {
          "type": "value",
          "value": "diagnosis_remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"10px\" , display: props.config?.hideDiagnosisRemark? \"none\": \"\"}"
        },
        "value": {
          "type": "code",
          "value": "props.diagnosis_remark || \"\""
        }
      },
      "seq": 81,
      "void": true
    },
    {
      "from": null,
      "id": 81,
      "name": "label",
      "parent": 74,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดเพิ่มเติม"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-81"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",textAlign: \"center\", display: props.config?.hideDiagnosisRemark? \"none\": \"\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormGroup",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormGroup-82"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-84"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-87"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-FormField-88"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "Position"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-89"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"70px\", maxWidth: \"70px\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "Dropdown",
      "parent": 84,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-Dropdown-90"
        },
        "name": {
          "type": "value",
          "value": "pre_operating_order_item.position"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.otherTrtPositionOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.position || \"\""
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Input",
      "parent": 85,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-Input-91"
        },
        "name": {
          "type": "value",
          "value": "pre_operating_order_item.other_position"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "placeholder": {
          "type": "value",
          "value": "Other position"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.showOtherPosition ? \"\": \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.otherPosition || \"\""
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "label",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": "Site"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-label-92"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "Checkbox",
      "parent": 87,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.siteRight || false"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-Checkbox-93"
        },
        "label": {
          "type": "value",
          "value": "Right"
        },
        "name": {
          "type": "value",
          "value": "pre_operating_order_item.site_right"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "Checkbox",
      "parent": 88,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.siteLeft || false"
        },
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-Checkbox-94"
        },
        "label": {
          "type": "value",
          "value": "Left"
        },
        "name": {
          "type": "value",
          "value": "pre_operating_order_item.site_left"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "TextArea",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgeryTeamUX-TextArea-95"
        },
        "name": {
          "type": "value",
          "value": "pre_operating_order_item.other_treatment"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "rows": {
          "type": "value",
          "value": "5"
        },
        "value": {
          "type": "code",
          "value": "props.otherTreatment || \"\""
        }
      },
      "seq": 95,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSurgeryTeamUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
